// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3cUeT","clinicsSelect":"TableHeading_clinicsSelect__39Odn"};